import GeneratedMailDomainServiceApi from "./generated/GeneratedMailDomainServiceApi"

class MailDomainServiceApi extends GeneratedMailDomainServiceApi {

}

export const mailDomainServiceApi = new MailDomainServiceApi()
